import React from "react";
import theme from "theme";
import { Theme, Image, LinkBox, Link, Box, Structure, Text, Section, Strong, Span, Em, List, Icon } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";
import * as Components from "components";
import { FaMaxcdn } from "react-icons/fa";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"bot/max/instrukciya"} />
		<Helmet>
			<title>
				Как сделать интернет магазин в MAX | uShopWebBot
			</title>
			<meta name={"description"} content={"Пошаговая инструкция по созданию интернет-магазина в Максе"} />
			<meta property={"og:title"} content={"Как сделать интернет магазин в MAX | uShopWebBot"} />
			<meta property={"og:description"} content={"Пошаговая инструкция по созданию интернет-магазина в Максе"} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/1.jpg?v=2022-12-25T20:50:47.139Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<meta name={"msapplication-TileImage"} content={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<meta name={"msapplication-TileColor"} content={"#000000"} />
		</Helmet>
		<Structure
			cells-number-total="2"
			quarkly-title="Navbar"
			position="relative"
			z-index="3"
			nout-z-index="9"
		>
			<Override
				slot="Content"
				grid-template-columns="3fr 1fr"
				nout-grid-template-columns="3fr 2fr"
				lg-grid-template-columns="1fr 1fr"
				md-grid-template-columns="1fr 2fr"
				sm-grid-template-columns="1fr"
				display="grid"
			>
				<Override slot="cell-0">
					<LinkBox href="/">
						<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z" display="block" />
					</LinkBox>
					<Components.QuarklycommunityKitMobileSidePanel menuPosition="right" breakpoint="nout">
						<Override
							slot="Content"
							background="rgba(255, 255, 255, 0)"
							md-background="--background"
							padding="8px 16px 8px 16px"
							nout-z-index="9999"
							nout-background="--background"
							justify-content="flex-start"
						/>
						<Override slot="Button Icon" size="32px" />
						<Override slot="Button Text" nout-text-transform="uppercase" nout-font="normal 500 16px/200% &quot;Montserrat&quot;, sans-serif" nout-letter-spacing="1px" />
						<Override slot="Wrapper" nout-z-index="9" />
						<Box
							width="100%"
							display="flex"
							grid-gap="32px"
							md-flex-direction="column"
							nout-flex-direction="column"
							nout-margin="20px 0px 0px 0px"
							nout-grid-gap="16px"
						>
							<Link
								href="/bot/instrukciya/#shop"
								color="#000000"
								font="--menu"
								text-decoration-line="initial"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								Создание интернет-магазина
							</Link>
							<Link
								href="/instrukciya/#bot"
								color="#000000"
								font="--menu"
								text-decoration-line="initial"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								Подключение бота
							</Link>
							<Link
								href="/instrukciya/#pay"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								Онлайн оплата
							</Link>
							<Link
								href="/instrukciya/#faq"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								FAQ
							</Link>
						</Box>
						<Box
							display="none"
							sm-display="flex"
							sm-flex-direction="column"
							sm-align-items="flex-start"
							sm-grid-gap="16px"
							sm-margin="16px 0px 0px 0px"
						>
							<Link
								href="/instrukciya"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								Инструкция
							</Link>
							<Link
								href="https://ucoz.ru/?utm_source=ucoz.ru/bot/max&utm_medium=button2&utm_campaign=main_botmax"
								color="--white"
								font="--button"
								text-decoration-line="initial"
								padding="12px 24px 12px 24px"
								background="--dark"
								border-radius="50px"
								transition="--opacityOut"
								hover-opacity=".8"
								target="_blank"
								md-padding="12px 20px 12px 20px"
								sm-align-self="center"
								sm-margin="20px 0px 0px 0px"
							>
								Создать веб-бота
							</Link>
						</Box>
					</Components.QuarklycommunityKitMobileSidePanel>
				</Override>
				<Override
					slot="Cell 0th"
					align-items="center"
					justify-content="flex-end"
					grid-gap="24px"
					display="flex"
					md-display="flex"
					md-grid-gap="16px"
				/>
				<Override slot="cell-1">
					<Components.ButtonBotMax />
				</Override>
				<Override slot="Cell 1" sm-display="none" />
			</Override>
		</Structure>
		<Section
			padding="180px 0 180px 0"
			background="linear-gradient(0deg,rgba(2, 2, 2, 0.18) 0%,rgba(2, 2, 2, 0.18) 99.5%),rgba(0, 0, 0, 0) url(https://uploads.quarkly.io/62ab65c921e43d0020961286/images/background1111.png?v=2022-08-25T10:45:21.612Z) center center/100% repeat scroll padding-box"
			sm-padding="50px 0 50px 0"
			lg-background="rgba(0, 0, 0, 0) url(https://uploads.quarkly.io/62ab65c921e43d0020961286/images/background1111.png?v=2022-08-25T10:45:21.612Z) center center/cover repeat scroll padding-box"
			md-padding="90px 0 90px 0"
		>
			<Text
				margin="0px 0px 0px 0px"
				font="--headline1"
				md-font="normal 800 32px/1.4 &quot;Montserrat&quot;, sans-serif"
				sm-font="normal 800 20px/1.4 &quot;Montserrat&quot;, sans-serif"
				color="--white"
				as="h1"
				md-text-align="center"
			>
				Пошаговая инструкция по созданию MAX магазина
			</Text>
			<Text
				margin="8px 0px 0px 0px"
				font="--headline3"
				color="--white"
				md-text-align="center"
				sm-font="normal 500 16px/24px &quot;Montserrat&quot;, sans-serif"
			>
				Создаем интернет-магазин в формате в веб-бота в четыре простых шага.
				<br />
				Сам бот создается без кода и за минут 15
			</Text>
		</Section>
		<Section padding="40px 0 40px 0" sm-padding="20px 0 20px 0" md-padding="60px 0 20px 0" display="none">
			<Text
				margin="0px 0px 8px 0px"
				font="--headline3"
				color="--dark"
				md-text-align="center"
				sm-font="normal 500 16px/24px &quot;Montserrat&quot;, sans-serif"
				sm-color="--dark"
				md-display="none"
			>
				Пошаговая видео-инструкция для создания магазина в Телеграм, выберите ваше устройство:{" "}
			</Text>
			<Text
				margin="0px 0px 8px 0px"
				font="--headline3"
				color="--dark"
				md-text-align="center"
				sm-font="normal 500 16px/24px &quot;Montserrat&quot;, sans-serif"
				sm-color="--dark"
				display="none"
				md-display="flex"
			>
				Пошаговая видео-инструкция для создания магазина в Телеграм:{" "}
			</Text>
			<Components.Tabs2 defaultTab="one">
				<Override slot="Tab one">
					💻 ПК
				</Override>
				<Override slot="Tab two">
					📱 Телефон
				</Override>
				<Override
					slot="Tab"
					border-radius="0px"
					width="100%"
					hover-opacity="1"
					color="--dark"
					focus-box-shadow="none"
					border-width="3px"
					border-style="solid"
					border-color="--color-primary"
					background="--background"
					font="--button"
				/>
				<Override slot="TabPanels" border-width="5px" border-style="solid" border-color="--color-primary" />
				<Override
					slot="Tab :active"
					border-radius="0px"
					border-color="--color-primary"
					border-width="3px"
					border-style="solid"
					background="--primary"
					color="--white"
				/>
				<Override slot="Tablist" md-display="none" />
				<Components.Tab2
					tabId="one"
					border-color="#0E86F8"
					border-width="2px"
					border-style="solid"
					md-display="none"
				>
					<Components.QuarklycommunityKitYouTube margin="0px 0px 0px 0px" url="https://www.youtube.com/watch?v=DejTcbdSEe0?showinfo=0&enablejsapi=1&origin=https://ucoz.ru/bot/" />
				</Components.Tab2>
				<Components.Tab2 tabId="two" border-width="2px" md-display="block">
					<Components.QuarklycommunityKitYouTube margin="0px 0px 0px 0px" url="https://www.youtube.com/watch?v=XWTXmlfZZC0?showinfo=0&enablejsapi=1&origin=https://ucoz.ru/" />
				</Components.Tab2>
			</Components.Tabs2>
			<Text
				margin="8px 0px 0px 0px"
				font="--headline3"
				color="--dark"
				md-text-align="center"
				sm-font="normal 500 16px/24px &quot;Montserrat&quot;, sans-serif"
				sm-color="--dark"
			>
				Если у вас возникнут вопросы при создании бота, можете написать в поддержку:{" "}
				<Link
					href="https://t.me/uShopHelpBot"
					border-color="--color-primary"
					text-decoration-line="initial"
					target="_blank"
					hover-opacity="0.7"
					color="--primary"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					hover-text-decoration-line="underline"
				>
					@uShopHelpBot
				</Link>
			</Text>
		</Section>
		<Section padding="40px 0 40px 0" sm-padding="20px 0 20px 0" md-padding="60px 0 20px 0" background="--background">
			<Text
				margin="0px 0px 40px 0px"
				font="--headline3"
				color="--darkL1"
				md-text-align="center"
				sm-font="normal 500 16px/24px &quot;Montserrat&quot;, sans-serif"
				sm-color="--dark"
				display="none"
			>
				Для тех кто не хочет смотреть видео или нет возможности, мы опишем порядок действий в текстовом формате.{" "}
			</Text>
			<Text
				id="shop"
				margin="0px 0px 24px 0px"
				font="--headline2"
				sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
				as="h2"
				color="--darkL1"
			>
				1. Создание интернет-магазина
			</Text>
			<Text margin="0px 0px 0px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--darkL1">
				Вся инструкция кажется большой, но на самом деле создание бота это - обычная регистрация аккаунта, сайта и бота, а после само оформление бота (аватарка, добавление товара и прочее). Но самое главное бот создается{" "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					полностью без кода
				</Strong>
				, то есть не нужны навыки программирования.{" "}
				<br />
				Давайте приступим к созданию нашего бота:{" "}
				<br />
				<br />
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					1.1.
				</Strong>
				{" "}Если у вас не создан у нас бот в Телеграм или сайт на нашей платформе, то вам необходимо зарегистрироваться и создать сайт на нашей платформе:{" "}
				<Link
					href="https://www.ucoz.ru/register?utm_source=ucoz.ru%2Fbot%2Fmax&utm_medium=button2&utm_campaign=main_botmax"
					target="_blank"
					color="--primary"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
				>
					uCoz
				</Link>
				<br />
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					1.2.
				</Strong>
				{" "}Далее вы попадете в панель управления и вам необходимо будет выбрать в разделе пункт "
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Бот-магазин
				</Strong>
				" и "
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Max-бот"
				</Strong>
			</Text>
			<Components.QuarklycommunityKitCollapse margin="4px 0px 0px 0px" padding="2px 2px 2px 2px" height="auto">
				<Override slot="Button" width="100%" text-align="left" font="--menu">
					Скриншот
				</Override>
				<Image
					src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/screenMax.png?v=2026-04-22T20:29:21.664Z"
					display="block"
					width="100%"
					srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/screenMax.png?v=2026-04-22T20%3A29%3A21.664Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/screenMax.png?v=2026-04-22T20%3A29%3A21.664Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/screenMax.png?v=2026-04-22T20%3A29%3A21.664Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/screenMax.png?v=2026-04-22T20%3A29%3A21.664Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/screenMax.png?v=2026-04-22T20%3A29%3A21.664Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/screenMax.png?v=2026-04-22T20%3A29%3A21.664Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/screenMax.png?v=2026-04-22T20%3A29%3A21.664Z&quality=85&w=3200 3200w"
					sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
				/>
			</Components.QuarklycommunityKitCollapse>
			<Text margin="0px 0px 0px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--darkL1">
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					1.3.
				</Strong>
				<Span
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{" "}Вам нужно будет пройти пред-модерацию и указать название вашей компании и ИИН, так как для создания бота-магазина в MAX обязательно наличие зарегистрированного ИП или ООО.
				</Span>
			</Text>
		</Section>
		<Section padding="40px 0 40px 0" sm-padding="20px 0 20px 0" md-padding="60px 0 20px 0">
			<Text id="bot" margin="0px 0px 24px 0px" font="--headline2" sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif">
				2. Создание бота в Макс
			</Text>
			<Text margin="0px 0px 0px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				Пока мы ждем модерацию, мы можем создать бота в Макс
				<br />
				<br />
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					2.1.{" "}
				</Strong>
				Перейдите на портал{" "}
				<Link
					href="https://business.max.ru/self/"
					color="--primary"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					target="_blank"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					business.max.ru/self/
				</Link>
				{" "}и войдите по номеру телефона.
				<br />
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					2.2
				</Strong>
				. 

Пройдите верификацию организации (выберите удобный способ): через ЕСИА / Госуслуги; через банковского провайдера.
				<br />
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					2.3.{" "}
				</Strong>
				После успешного подтверждения организации вы сможете: авторизоваться на портале и создать бота.
				<br />
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					2.4.{" "}
				</Strong>
				<Span
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					К
				</Span>
				<Span
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					ак только бот будет создан и промодерирован, вам необходимо будет в разделе "
					<Strong
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						Интеграция
					</Strong>
					" скопировать токен и этот токен установить в нашей панели управления:{" "}
				</Span>
			</Text>
			<Components.QuarklycommunityKitCollapse margin="4px 0px 0px 0px" padding="2px 2px 2px 2px" height="auto">
				<Override slot="Button" width="100%" text-align="left" font="--menu">
					Скриншот
				</Override>
				<Image
					src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/screenMaxTOken.png?v=2026-04-22T20:36:05.019Z"
					display="block"
					width="100%"
					srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/screenMaxTOken.png?v=2026-04-22T20%3A36%3A05.019Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/screenMaxTOken.png?v=2026-04-22T20%3A36%3A05.019Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/screenMaxTOken.png?v=2026-04-22T20%3A36%3A05.019Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/screenMaxTOken.png?v=2026-04-22T20%3A36%3A05.019Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/screenMaxTOken.png?v=2026-04-22T20%3A36%3A05.019Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/screenMaxTOken.png?v=2026-04-22T20%3A36%3A05.019Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/screenMaxTOken.png?v=2026-04-22T20%3A36%3A05.019Z&quality=85&w=3200 3200w"
					sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
				/>
				<Image
					src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/botmaxtok.png?v=2026-04-22T20:37:41.737Z"
					display="block"
					width="100%"
					margin="10px 0px 0px 0px"
					srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/botmaxtok.png?v=2026-04-22T20%3A37%3A41.737Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/botmaxtok.png?v=2026-04-22T20%3A37%3A41.737Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/botmaxtok.png?v=2026-04-22T20%3A37%3A41.737Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/botmaxtok.png?v=2026-04-22T20%3A37%3A41.737Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/botmaxtok.png?v=2026-04-22T20%3A37%3A41.737Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/botmaxtok.png?v=2026-04-22T20%3A37%3A41.737Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/botmaxtok.png?v=2026-04-22T20%3A37%3A41.737Z&quality=85&w=3200 3200w"
					sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
				/>
			</Components.QuarklycommunityKitCollapse>
			<Text margin="0px 0px 0px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					2.5.{" "}
				</Strong>
				<Span
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Далее вам нужно будет зайти в раздел "Настройки модуля" и там перейти во вкладку "Кнопки и ссылки" и там скопировать ссылку в поле "
Endpoint для интеграции с MAX"
				</Span>
			</Text>
			<Components.QuarklycommunityKitCollapse margin="4px 0px 0px 0px" padding="2px 2px 2px 2px" height="auto">
				<Override slot="Button" width="100%" text-align="left" font="--menu">
					Скриншот
				</Override>
				<Image
					src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ednpointmax.png?v=2026-04-22T20:43:56.260Z"
					display="block"
					width="100%"
					margin="10px 0px 0px 0px"
					srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/ednpointmax.png?v=2026-04-22T20%3A43%3A56.260Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/ednpointmax.png?v=2026-04-22T20%3A43%3A56.260Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/ednpointmax.png?v=2026-04-22T20%3A43%3A56.260Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/ednpointmax.png?v=2026-04-22T20%3A43%3A56.260Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/ednpointmax.png?v=2026-04-22T20%3A43%3A56.260Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/ednpointmax.png?v=2026-04-22T20%3A43%3A56.260Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/ednpointmax.png?v=2026-04-22T20%3A43%3A56.260Z&quality=85&w=3200 3200w"
					sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
				/>
			</Components.QuarklycommunityKitCollapse>
			<Text margin="0px 0px 0px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					2.6.{" "}
				</Strong>
				<Span
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Этот адрес вам нужно установить в раздел "Чат-бот и мини-приложение" в поле "Введите ссылку мини-приложения":
				</Span>
			</Text>
			<Components.QuarklycommunityKitCollapse margin="4px 0px 0px 0px" padding="2px 2px 2px 2px" height="auto">
				<Override slot="Button" width="100%" text-align="left" font="--menu">
					Скриншот
				</Override>
				<Image
					src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/miniappmax.png?v=2026-04-22T20:46:42.733Z"
					display="block"
					width="100%"
					margin="10px 0px 0px 0px"
					srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/miniappmax.png?v=2026-04-22T20%3A46%3A42.733Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/miniappmax.png?v=2026-04-22T20%3A46%3A42.733Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/miniappmax.png?v=2026-04-22T20%3A46%3A42.733Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/miniappmax.png?v=2026-04-22T20%3A46%3A42.733Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/miniappmax.png?v=2026-04-22T20%3A46%3A42.733Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/miniappmax.png?v=2026-04-22T20%3A46%3A42.733Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/miniappmax.png?v=2026-04-22T20%3A46%3A42.733Z&quality=85&w=3200 3200w"
					sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
				/>
			</Components.QuarklycommunityKitCollapse>
		</Section>
		<Section padding="40px 0 40px 0" sm-padding="20px 0 20px 0" md-padding="60px 0 20px 0" background="--background">
			<Text margin="0px 0px 24px 0px" font="--headline2" sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif" as="h2">
				3. Оформление бота
			</Text>
			<Text margin="0px 0px 0px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				Ура 🥳! Вот мы и создали бота. Но это только половина пути. Теперь нам нужно его оформить и заполнить товарами
				<br />
				<br />
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					3.1.
				</Strong>
				{" "}Все что касается оформления самого бота (аватарка, описание бота), то есть вся та информация которая отображается до запуска бота, она полностью настраивается в "Бизнес Макс"
				<br />
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					3.2.
				</Strong>
				{" "}Информация которая отображается внутри бота (текст приветствия, название и текст кнопок, цвет и дизайн бота и пр.), это настраивается в разделе "Настройки модуля"
			</Text>
			<Components.QuarklycommunityKitCollapse margin="4px 0px 0px 0px" padding="2px 2px 2px 2px" height="auto">
				<Override slot="Button" width="100%" text-align="left" font="--menu">
					Скриншоты
				</Override>
				<Image
					src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/smenadesing.png?v=2024-11-01T14:26:22.919Z"
					display="block"
					width="100%"
					srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/smenadesing.png?v=2024-11-01T14%3A26%3A22.919Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/smenadesing.png?v=2024-11-01T14%3A26%3A22.919Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/smenadesing.png?v=2024-11-01T14%3A26%3A22.919Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/smenadesing.png?v=2024-11-01T14%3A26%3A22.919Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/smenadesing.png?v=2024-11-01T14%3A26%3A22.919Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/smenadesing.png?v=2024-11-01T14%3A26%3A22.919Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/smenadesing.png?v=2024-11-01T14%3A26%3A22.919Z&quality=85&w=3200 3200w"
					sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
				/>
				<Text margin="8px 0px 4px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
					После чего вы попадете в панель управления вашего бота и там вам необходимо указать свои текста - контакты, информацию, о магазине, текст приветствия и прочее:
				</Text>
				<Image
					src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/knopkissilka.png?v=2024-11-01T15:14:17.253Z"
					display="block"
					width="100%"
					srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/knopkissilka.png?v=2024-11-01T15%3A14%3A17.253Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/knopkissilka.png?v=2024-11-01T15%3A14%3A17.253Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/knopkissilka.png?v=2024-11-01T15%3A14%3A17.253Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/knopkissilka.png?v=2024-11-01T15%3A14%3A17.253Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/knopkissilka.png?v=2024-11-01T15%3A14%3A17.253Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/knopkissilka.png?v=2024-11-01T15%3A14%3A17.253Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/knopkissilka.png?v=2024-11-01T15%3A14%3A17.253Z&quality=85&w=3200 3200w"
					sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
				/>
			</Components.QuarklycommunityKitCollapse>
		</Section>
		<Section padding="40px 0 40px 0" sm-padding="20px 0 20px 0" md-padding="60px 0 20px 0">
			<Text margin="0px 0px 24px 0px" font="--headline2" sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif" as="h2">
				4. Добавление товара
			</Text>
			<Text margin="0px 0px 4px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				<Span
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Теперь мы должны определится как мы добавляем товар, а именно это ручное добавление или импорт товара с какого-нибудь источника (с вашего старого сайта, Мой Склад, 1С, Яндекс.Маркета или просто с прайса Excel)
					<br />
					<br />
					<Strong
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						4.1.{" "}
					</Strong>
				</Span>
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Добавление товара вручную:
					<br />
				</Strong>
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					4.1.1. Категории товара.
				</Strong>
				{" "}Зайдите в ваш созданный бот-магазин и пропишите в нем команду /admin и выберите раздел "Управление категориями" и там удалите стандартные категории и создайте свои
			</Text>
			<Components.QuarklycommunityKitCollapse margin="4px 0px 16px 0px" padding="2px 2px 2px 2px" height="auto">
				<Override slot="Button" width="100%" text-align="left" font="--menu">
					Скриншот
				</Override>
				<Image
					src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/kategoriitovara.png?v=2024-11-01T16:43:40.829Z"
					display="block"
					width="100%"
					srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kategoriitovara.png?v=2024-11-01T16%3A43%3A40.829Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kategoriitovara.png?v=2024-11-01T16%3A43%3A40.829Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kategoriitovara.png?v=2024-11-01T16%3A43%3A40.829Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kategoriitovara.png?v=2024-11-01T16%3A43%3A40.829Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kategoriitovara.png?v=2024-11-01T16%3A43%3A40.829Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kategoriitovara.png?v=2024-11-01T16%3A43%3A40.829Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kategoriitovara.png?v=2024-11-01T16%3A43%3A40.829Z&quality=85&w=3200 3200w"
					sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
				/>
			</Components.QuarklycommunityKitCollapse>
			<Text margin="0px 0px 4px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					4.1.2 Вариации/Опции товара.
				</Strong>
				{" "}
				<Em
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					(пункт выполнять не обязательно)
				</Em>
				<br />
				Если вам необходимо, чтобы при оформлении заказа у товара был выбор характеристик, например: выбор цвета, размера, вкуса и пр. То для этого вы можете создать опции товара. Пример опций в бот-магазине:{" "}
				<Link
					href="https://t.me/SportClothesBot/menu?startapp=product_220"
					text-decoration-line="initial"
					target="_blank"
					color="--primary"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					hover-text-decoration-line="underline"
				>
					Выбор размера и цвета одежды
				</Link>
				,{" "}
				<Link
					href="https://t.me/Dolce_Bot/menu?startapp=product_15"
					text-decoration-line="initial"
					target="_blank"
					color="--primary"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					hover-text-decoration-line="underline"
				>
					Выбор сета и количества в доставке
				</Link>
			</Text>
			<Components.QuarklycommunityKitCollapse margin="4px 0px 16px 0px" padding="2px 2px 2px 2px" height="auto">
				<Override slot="Button" width="100%" text-align="left" font="--menu">
					Скриншот
				</Override>
				<Image
					src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/opciitovara.png?v=2024-11-01T16:52:02.212Z"
					display="block"
					width="100%"
					srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/opciitovara.png?v=2024-11-01T16%3A52%3A02.212Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/opciitovara.png?v=2024-11-01T16%3A52%3A02.212Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/opciitovara.png?v=2024-11-01T16%3A52%3A02.212Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/opciitovara.png?v=2024-11-01T16%3A52%3A02.212Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/opciitovara.png?v=2024-11-01T16%3A52%3A02.212Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/opciitovara.png?v=2024-11-01T16%3A52%3A02.212Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/opciitovara.png?v=2024-11-01T16%3A52%3A02.212Z&quality=85&w=3200 3200w"
					sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
				/>
			</Components.QuarklycommunityKitCollapse>
			<Text margin="0px 0px 4px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					4.1.3 Размещение товара.{" "}
				</Strong>
				<Span
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Вот мы и перешли к основному. Добавление товара происходит прямо в вашем бот-магазине, вам нужно также прописать команду /admin и выбрать пункт "📥 Добавить товар"
				</Span>
			</Text>
			<Components.QuarklycommunityKitCollapse margin="4px 0px 24px 0px" padding="2px 2px 2px 2px" height="auto">
				<Override slot="Button" width="100%" text-align="left" font="--menu">
					Скриншоты
				</Override>
				<Image
					src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/dodavittovatr.png?v=2024-11-01T17:16:34.620Z"
					display="block"
					width="100%"
					srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/dodavittovatr.png?v=2024-11-01T17%3A16%3A34.620Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/dodavittovatr.png?v=2024-11-01T17%3A16%3A34.620Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/dodavittovatr.png?v=2024-11-01T17%3A16%3A34.620Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/dodavittovatr.png?v=2024-11-01T17%3A16%3A34.620Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/dodavittovatr.png?v=2024-11-01T17%3A16%3A34.620Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/dodavittovatr.png?v=2024-11-01T17%3A16%3A34.620Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/dodavittovatr.png?v=2024-11-01T17%3A16%3A34.620Z&quality=85&w=3200 3200w"
					sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
				/>
				<Text margin="8px 0px 4px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
					В случае если вы продаете услуги или цифровой товар (файлы, ключи, ссылки, коды и пр.), то вам нужно изменить тип товара.{" "}
					<Link
						href="/prodazha-elektronnykh-tovarov-v-telegram"
						color="--primary"
						text-decoration-line="initial"
						target="_blank"
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						Подробная инструкция
					</Link>
				</Text>
				<Image
					src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/tiptovara.png?v=2024-11-01T17:23:37.445Z"
					display="block"
					width="100%"
					srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tiptovara.png?v=2024-11-01T17%3A23%3A37.445Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tiptovara.png?v=2024-11-01T17%3A23%3A37.445Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tiptovara.png?v=2024-11-01T17%3A23%3A37.445Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tiptovara.png?v=2024-11-01T17%3A23%3A37.445Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tiptovara.png?v=2024-11-01T17%3A23%3A37.445Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tiptovara.png?v=2024-11-01T17%3A23%3A37.445Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tiptovara.png?v=2024-11-01T17%3A23%3A37.445Z&quality=85&w=3200 3200w"
					sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
				/>
			</Components.QuarklycommunityKitCollapse>
			<Text margin="12px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					4.2. Массовый импорт товара:
					<br />
				</Strong>
				Если вам ручное добавление не подходит, то у нас есть импорт товара с Excel (XLS/XLSX/CSV/Google Docs) и 1C, YML(Яндекс.Маркет), Мой Склад и пр.
				<br />
				При импорте товара вам не нужно создавать опции и категории, они автоматически подтягиваются при импорте.
				<br />
				<br />
				Инструкции:
			</Text>
			<List
				margin="0px 0px 0px 0px"
				padding="0px 0px 0px 20px"
				list-style-type="disc"
				as="ul"
				font="--base"
			>
				<Text margin="0px 0px 0px 0px">
					<Link
						href="https://www.ucoz.ru/help/online-shop/import-tovarov"
						color="--primary"
						text-decoration-line="initial"
						target="_blank"
						hover-text-decoration-line="underline"
					>
						Импорт товаров из XLS/XLSX/Google Docs
					</Link>
				</Text>
				<Text margin="0px 0px 0px 0px">
					<Link
						href="https://www.ucoz.ru/help/online-shop/unload-goods-1c"
						color="--primary"
						text-decoration-line="initial"
						target="_blank"
						hover-text-decoration-line="underline"
					>
						Выгружаем товары в интернет-магазин с «1С»
					</Link>
				</Text>
				<Text margin="0px 0px 0px 0px">
					<Link
						href="https://www.ucoz.ru/help/online-shop/import-tovarov-yml"
						color="--primary"
						text-decoration-line="initial"
						target="_blank"
						hover-text-decoration-line="underline"
					>
						Импорт товаров из YML
					</Link>
				</Text>
				<Text margin="0px 0px 0px 0px">
					<Link
						href="https://www.ucoz.ru/help/online-shop/exchange/moysklad"
						color="--primary"
						text-decoration-line="initial"
						target="_blank"
						hover-text-decoration-line="underline"
					>
						Подключение товароучетной системы «МойСклад»
					</Link>
				</Text>
			</List>
		</Section>
		<Section padding="40px 0 40px 0" sm-padding="20px 0 20px 0" md-padding="60px 0 20px 0" background="--background">
			<Text
				id="pay"
				margin="0px 0px 24px 0px"
				font="--headline2"
				sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
				as="h2"
			>
				5. Настройки валют и учет остатка
			</Text>
			<Text margin="0px 0px 4px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				<Span
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					<Strong
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						5.1. Настройка валюты.{" "}
					</Strong>
					Вы можете принимать оплату за ваш товар в любой валюте: Рублях, Гривнах, Тенге, Сум, Долларах, Евро, Фунтах и в других 77 валютах. 
А также можно принимать оплату при помощи криптовалют (USDT, BTC, ETH, TON и пр.)
				</Span>
				<br />
				Редактировать валюту вы можете в разделе /admin - пункт "Панель управления" и выбираете раздел "Оплата и доставка":
				<Link
					href="https://t.me/Dolce_Bot/menu?startapp=product_15"
					text-decoration-line="initial"
					target="_blank"
					color="--primary"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				/>
			</Text>
			<Components.QuarklycommunityKitCollapse margin="4px 0px 16px 0px" padding="2px 2px 2px 2px" height="auto">
				<Override slot="Button" width="100%" text-align="left" font="--menu">
					Скриншот
				</Override>
				<Image
					src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/valutared.png?v=2024-11-01T18:24:58.004Z"
					display="block"
					width="100%"
					srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/valutared.png?v=2024-11-01T18%3A24%3A58.004Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/valutared.png?v=2024-11-01T18%3A24%3A58.004Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/valutared.png?v=2024-11-01T18%3A24%3A58.004Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/valutared.png?v=2024-11-01T18%3A24%3A58.004Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/valutared.png?v=2024-11-01T18%3A24%3A58.004Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/valutared.png?v=2024-11-01T18%3A24%3A58.004Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/valutared.png?v=2024-11-01T18%3A24%3A58.004Z&quality=85&w=3200 3200w"
					sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
				/>
			</Components.QuarklycommunityKitCollapse>
			<Text margin="0px 0px 4px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					5.2. Учет остатка товара.
				</Strong>
				{" "}
				<Em
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					(пункт выполнять не обязательно)
				</Em>
				<br />
				У всех физических товаров в интернет-магазине есть поле, отвечающее за наличие или дату поставки товара. С функцией учета остатков вы сможете:
			</Text>
			<List
				margin="0px 0px 0px 0px"
				padding="0px 0px 0px 20px"
				list-style-type="disc"
				as="ul"
				font="--base"
			>
				<Text margin="0px 0px 0px 0px">
					Автоматически вычитать купленные товары
				</Text>
				<Text margin="0px 0px 0px 0px">
					Запрещать добавление в корзину товаров с нулевым остатком
				</Text>
				<Text margin="0px 0px 0px 0px">
					Автоматически скрывать товары, которых нет в наличии
				</Text>
				<Text margin="0px 0px 0px 0px">
					Импортировать остатки из прайсов XLS и 1C
				</Text>
			</List>
			<Text margin="6px 0px 0px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				<Strong>
					<Link
						href="https://www.ucoz.ru/help/online-shop/uchet-ostatkov"
						target="_blank"
						color="--primary"
						text-decoration-line="initial"
						hover-text-decoration-line="underline"
					>
						<Span
							font-weight="normal"
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Инструкция по работе с остатками
						</Span>
					</Link>
				</Strong>
			</Text>
		</Section>
		<Section padding="40px 0 40px 0" sm-padding="20px 0 20px 0" md-padding="60px 0 20px 0">
			<Text
				id="pay"
				margin="0px 0px 24px 0px"
				font="--headline2"
				sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
				as="h2"
			>
				6. Подключение онлайн оплат
			</Text>
			<Text
				margin="0px 0px 16px 0px"
				font="--base"
				sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif"
				overflow-wrap="break-word"
				word-break="normal"
			>
				В боте можно подключить платёжные сервисы, которые позволяют принимать оплату в рублях, гривнах, тенге, сумах, долларах, евро, фунтах и ещё в 77 других валютах, не покидая диалог с ботом.
				<br />
				<br />
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					6.1. Подключение оплаты от uCoz:
				</Strong>
				<br />
				У нас есть внутренние прямые интеграции с платежными системами:{" "}
				<br />
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/yookassa"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					ЮKassa
				</Link>
				,{" "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/yoomoney-dlya-fiz-lic"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					ЮMoney для физ. лиц
				</Link>
				,{" "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/tinkoff"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					Т-Банк
				</Link>
				,{" "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/sberbank"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					Сбербанк
				</Link>
				,{" "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/liqpay"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					LiqPay
				</Link>
				,{" "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/wallet-one"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					Wallet One
				</Link>
				,{" "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/robokassa"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					ROBOKASSA
				</Link>
				,{" "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/fondy"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					Fondy
				</Link>
				,{" "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/paypal"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					PayPal
				</Link>
				,
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/webmoney"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					{" "}WebMoney
				</Link>
				,{" "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/freekassa"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					Freekassa
				</Link>
				,{" "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/unitpay"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					UnitPay
				</Link>
				,{" "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/cloudpayments"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					CloudPayments
				</Link>
				,{" "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/stripe"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					Stripe
				</Link>
				,{" "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/sberbank-credit"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					Сбербанк кредит
				</Link>
				,{" "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/enotio"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					enot.io
				</Link>
				,{" "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/antilopay"
					target="_blank"
					color="--primary"
					hover-text-decoration-line="underline"
					text-decoration-line="initial"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					AntiloPay
				</Link>
				,{" "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/wata"
					target="_blank"
					color="--primary"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Wata
				</Link>
				,{" "}
				<Link
					href="https://www.ucoz.ru/bot/onlayn-oplata-v-telegram-magazine/"
					color="--primary"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					target="_blank"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					CryptoBot
				</Link>
				,{" "}
				<Link
					href="https://t.me/uShopWeb/47"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					color="--primary"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					target="_blank"
				>
					Telegram Stars
				</Link>
				,{" "}
				<Link
					href="/oplata-kriptoi-v-telegram-magazine"
					target="_blank"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					xRocket
				</Link>
			</Text>
			<Text
				margin="0px 0px 16px 0px"
				font="--base"
				sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif"
				overflow-wrap="break-word"
				word-break="normal"
			>
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					6.2. П
				</Strong>
				<Span
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					<Strong
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						олуавтоматический прием оплаты
					</Strong>
				</Span>
				<br />
				В случае если у вас в данный момент нет возможности подключить онлайн оплату или в данный момент нет необходимой платежной системы, вы можете использовать полуавтоматический режим. В этом случае бот за вас будет присылать ваши реквизиты (карты, номера телефона и пр.) для перевода средств.{" "}
				<Link href="/poluavtomaticheskiy-priyem-oplaty/" text-decoration-line="initial" color="--primary" hover-text-decoration-line="underline">
					Инструкция по подключению
				</Link>
			</Text>
			<Text margin="0px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					6.3. Подключение Telegram оплаты:
				</Strong>
				<br />
				Для Telegram по стандарту интегрированы следующие платежные системы: ЮKassa, Tranzzo (Interkassa), Stripe, UnitPay, PaycomUZ / Payme, CLICK Uzbekistan, Rave by Flutterwave, LiqPay, Smart Glocal, Unlimint, Paykassma, PSB, Bank 131, LeoGaming, Cascad, Paymega, Portmone, Global Pay UZ, iPay88, ECOMMPAY и PayMaster.
				<br />
				<br />
				Чтобы подключить эти оплаты от Telegram, вам нужно зайти в раздел "🛠
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{" "}Настройки бота
				</Strong>
				" (/mybot) в боте{" "}
				<Link
					href="https://t.me/uShopWebBot"
					text-decoration-line="initial"
					color="--primary"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					transition="opacity 1s ease-in-out 0s"
				>
					@uShopWebBot{" "}
				</Link>
				<br />
				И там выбрать раздел "💰 Оплата", после чего отправить название оплаты и токен платежной системы.
				<br />
				<br />
				Получить токен платежной системы вы можете в{" "}
				<Link
					href="https://t.me/BotFather"
					target="_blank"
					text-decoration-line="initial"
					color="--primary"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					@Botfather
				</Link>
				, для этого вам необходимо будет зайти в настройки вашего бота и выбрать раздел "
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Payments
				</Strong>
				"
			</Text>
			<Components.QuarklycommunityKitCollapse margin="4px 0px 0px 0px" padding="2px 2px 2px 2px" height="auto">
				<Override slot="Button" width="100%" text-align="left" font="--menu">
					Скриншоты
				</Override>
				<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/payments.png?v=2022-08-26T21:14:37.737Z" display="block" srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/payments.png?v=2022-08-26T21%3A14%3A37.737Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/payments.png?v=2022-08-26T21%3A14%3A37.737Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/payments.png?v=2022-08-26T21%3A14%3A37.737Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/payments.png?v=2022-08-26T21%3A14%3A37.737Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/payments.png?v=2022-08-26T21%3A14%3A37.737Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/payments.png?v=2022-08-26T21%3A14%3A37.737Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/payments.png?v=2022-08-26T21%3A14%3A37.737Z&quality=85&w=3200 3200w" sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw" />
				<Text margin="8px 0px 16px 0px" font="--base" sm-font="normal 500 14px/180% &quot;Montserrat&quot;, sans-serif">
					После чего, вам необходимо выбрать платежную систему, которую вы хотите подключить для приема платежей и активировать её.
				</Text>
				<Image
					src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/paybotfather.png?v=2024-11-04T14:38:33.772Z"
					display="block"
					width="100%"
					srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paybotfather.png?v=2024-11-04T14%3A38%3A33.772Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paybotfather.png?v=2024-11-04T14%3A38%3A33.772Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paybotfather.png?v=2024-11-04T14%3A38%3A33.772Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paybotfather.png?v=2024-11-04T14%3A38%3A33.772Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paybotfather.png?v=2024-11-04T14%3A38%3A33.772Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paybotfather.png?v=2024-11-04T14%3A38%3A33.772Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paybotfather.png?v=2024-11-04T14%3A38%3A33.772Z&quality=85&w=3200 3200w"
					sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
				/>
			</Components.QuarklycommunityKitCollapse>
			<Text
				margin="20px 0px 0px 0px"
				font="normal 500 20px/28px --fontFamily-googleMontserrat"
				color="--darkL1"
				md-text-align="center"
				sm-font="normal 500 16px/24px &quot;Montserrat&quot;, sans-serif"
				sm-color="--dark"
			>
				Если ни один из способов оплаты вам не подходит, вы можете запросить интеграцию нужного способа в нашей службе поддержки
			</Text>
		</Section>
		<Section padding="40px 0 40px 0" sm-padding="20px 0 20px 0" md-padding="60px 0 20px 0" background="--background">
			<Text margin="0px 0px 24px 0px" font="--headline2" sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif" as="h2">
				7. Интеграция служб доставки
			</Text>
			<Text margin="12px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				Если продаете товар/продукт с доставкой, то вы можете интегрировать службы доставки, чтобы они предоставили список своих ПВЗ и делали расчет доставки исходя из расстояния, веса и габбаритов вашей посылки.
				<br />
				<br />
				Инструкции:
			</Text>
			<List
				margin="0px 0px 0px 0px"
				padding="0px 0px 0px 20px"
				list-style-type="disc"
				as="ul"
				font="--base"
			>
				<Text margin="0px 0px 0px 0px">
					<Link
						href="https://www.ucoz.ru/help/online-shop/dostavka/sdek"
						color="--primary"
						text-decoration-line="initial"
						target="_blank"
						hover-text-decoration-line="underline"
					>
						Интеграция службы доставки СДЭК
					</Link>
				</Text>
				<Text margin="0px 0px 0px 0px">
					<Link
						href="https://www.ucoz.ru/help/online-shop/dostavka/pochta_ru"
						color="--primary"
						target="_blank"
						text-decoration-line="initial"
						hover-text-decoration-line="underline"
					>
						Подключение Почты России
					</Link>
				</Text>
				<Text margin="0px 0px 0px 0px">
					<Link
						href="https://www.ucoz.ru/help/online-shop/dostavka/novaposhta"
						color="--primary"
						target="_blank"
						text-decoration-line="initial"
						hover-text-decoration-line="underline"
					>
						Почтовая служба Нова Пошта
					</Link>
				</Text>
				<Text margin="0px 0px 0px 0px">
					<Link
						href="https://www.ucoz.ru/help/online-shop/dostavka/apiship"
						color="--primary"
						target="_blank"
						text-decoration-line="initial"
						hover-text-decoration-line="underline"
					>
						Интегратор служб доставки ApiShip
					</Link>
					, с его помощью можно подключить такие сервисы как: Яндекс.Доставка, Сберлогистик, Достависта, Деловые Линии, Boxberry и прочие
				</Text>
				<Text margin="0px 0px 0px 0px">
					<Link
						href="https://www.ucoz.ru/help/online-shop/dostavka/matrica-formirovaniya-cen"
						color="--primary"
						text-decoration-line="initial"
						target="_blank"
						hover-text-decoration-line="underline"
					>
						Матрица формирования цен на доставку
					</Link>
					{" "}без служб доставки
				</Text>
			</List>
		</Section>
		<Section
			id="faq"
			padding="60px 0 90px 0"
			background="--white"
			position="relative"
			md-padding="60px 0 60px 0"
			sm-padding="30px 0 60px 0"
		>
			<Override
				slot="SectionContent"
				width="90%"
				max-width="1320px"
				align-items="center"
				padding="60px 30px 60px 30px"
				background="--background"
				border-radius="32px"
				md-padding="40px 20px 40px 20px"
				sm-width="95%"
			/>
			<Box max-width="1280px" width="100%">
				<Text
					margin="0px 0px 36px 0px"
					color="--darkL1"
					font="--headline1"
					md-text-align="center"
					sm-font="normal 800 30px/1.4 &quot;Montserrat&quot;, sans-serif"
					lg-text-align="center"
					lg-font="normal 800 32px/1.4 &quot;Montserrat&quot;, sans-serif"
				>
					FAQ - Часто задаваемые вопросы
				</Text>
				<Components.QuarklycommunityKitCollapse
					width="100%"
					padding="0px 0px 8px 0px"
					border-width="0px"
					border-style="none"
					sm-margin="0px 0px 6px 0px"
					sm-text-align="center"
				>
					<Override
						slot="Button"
						font="--headline2"
						background="none"
						color="--dark"
						padding="8px 24px 8px 0px"
						sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
						lg-width="100%"
						lg-text-align="center"
						lg-padding="8px 0px 8px 0px"
						transition="opacity 0.2s ease-in-out 0s"
						hover-opacity="0.6"
					>
						Чем наш сервис отличается от других сервисов?
						<Strong
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						/>
					</Override>
					<Text margin="0px 0px 0px 0px" font="--base">
						Мы являемся первым конструктором веб-ботов в направлении E-commerce, у нас вы можете самостоятельно создать MAX-магазин буквально за 10 минут. У нас нет лишних функций, а интерфейс интуитивно понятен каждому. Просто создайте бота, подключите его к нашему конструктору, загрузите товары и начните продавать в Максе.
					</Text>
				</Components.QuarklycommunityKitCollapse>
				<Components.QuarklycommunityKitCollapse
					width="100%"
					padding="0px 0px 8px 0px"
					border-width="0px"
					border-style="none"
					sm-margin="0px 0px 6px 0px"
					sm-text-align="center"
				>
					<Override
						slot="Button"
						font="--headline2"
						background="none"
						color="--dark"
						padding="8px 24px 8px 0px"
						sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
						lg-width="100%"
						lg-text-align="center"
						lg-padding="8px 0px 8px 0px"
						transition="opacity 0.2s ease-in-out 0s"
						hover-opacity="0.6"
					>
						Какие возможности кроме продаж в MAX есть у бота?
					</Override>
					<Text margin="0px 0px 0px 0px" font="--base">
						Помимо продажи товара и приема онлайн платежей, бот может делать следующее:
					</Text>
					<List
						margin="0px 0px 0px 0px"
						padding="0px 0px 0px 20px"
						list-style-type="disc"
						as="ul"
						font="--base"
					>
						<Text margin="0px 0px 0px 0px">
							Делать рассылки на всех пользователей которые запустили вашего бота, например вы можете оповестить о каких-либо скидках или акциях на товар;
						</Text>
						<Text margin="0px 0px 0px 0px">
							Создавать промо-коды;
						</Text>
						<Text margin="0px 0px 0px 0px">
							Создать дополнительную кнопку в меню бота и разместить там ваши контакты;
						</Text>
						<Text margin="0px 0px 0px 0px">
							Просматривать статистику вашего бота;
						</Text>
						<Text margin="0px 0px 0px 0px">
							Получать уведомления о новых заказах прямо в боте;
						</Text>
						<Text margin="0px 0px 0px 0px">
							А также помимо бота, вы  создаете полноценный интернет-магазин, со всем необходимым функционалом, который также входит в один тариф.
						</Text>
					</List>
				</Components.QuarklycommunityKitCollapse>
				<Components.QuarklycommunityKitCollapse
					width="100%"
					padding="0px 0px 8px 0px"
					border-width="0px"
					border-style="none"
					sm-margin="0px 0px 6px 0px"
					sm-text-align="center"
				>
					<Override
						slot="Button"
						font="--headline2"
						background="none"
						color="--dark"
						padding="8px 24px 8px 0px"
						sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
						lg-width="100%"
						lg-text-align="center"
						lg-padding="8px 0px 8px 0px"
						transition="opacity 0.2s ease-in-out 0s"
						hover-opacity="0.6"
					>
						Какие платежные системы и валюты доступны в боте?
					</Override>
					<Text margin="0px 0px 0px 0px" font="--base">
						В боте возможно подключить платёжные сервисы с возможностью принимать оплату в{" "}
						<Em
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Рублях
						</Em>
						,{" "}
						<Em
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Гривнах
						</Em>
						,{" "}
						<Em
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Тенге
						</Em>
						,{" "}
						<Em
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Сум
						</Em>
						,{" "}
						<Em
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Долларах
						</Em>
						,{" "}
						<Em
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Евро
						</Em>
						,{" "}
						<Em
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Фунтах{" "}
						</Em>
						и в других 77 валютах оставаясь в диалоге с ботом.
						<br />
						<br />
						Платежные системы которые доступны внутри Telegram:{" "}
						<Strong
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							ЮКасса (Яндекс.Касса), Сбербанк, Т-Банк, АльфаБанк, Tranzzo (Interkassa), Stripe, Paycom.Uz / Payme, CLICK Uzbekistan, Rave by Flutterwave,
						</Strong>
						{" "}
						<Strong
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							LiqPay, Smart Glocal, Unlimint, Paykassma, PSB, Bank 131, LeoGaming, Cascad, Paymega, Portmone, Global Pay UZ, iPay88, ECOMMPAY
						</Strong>
						{" "}и{" "}
						<Span
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							<Strong
								overflow-wrap="normal"
								word-break="normal"
								white-space="normal"
								text-indent="0"
								text-overflow="clip"
								hyphens="manual"
								user-select="auto"
								pointer-events="auto"
							>
								PayMaster.
							</Strong>
							<br />
							<br />
							<Strong
								overflow-wrap="normal"
								word-break="normal"
								white-space="normal"
								text-indent="0"
								text-overflow="clip"
								hyphens="manual"
								user-select="auto"
								pointer-events="auto"
							>
								Важно!{" "}
							</Strong>
							Если вы не зарегистрированы в качестве Юридического лица (ИП, ООО и так далее), то вам подойдут: ЮМани (Яндекс.Деньги), Enot, Wata, AntiloPay, OverPay и CardLink
							<br />
						</Span>
					</Text>
				</Components.QuarklycommunityKitCollapse>
				<Components.QuarklycommunityKitCollapse
					width="100%"
					padding="0px 0px 8px 0px"
					border-width="0px"
					border-style="none"
					sm-margin="0px 0px 6px 0px"
					sm-text-align="center"
				>
					<Override
						slot="Button"
						font="--headline2"
						background="none"
						color="--dark"
						padding="8px 24px 8px 0px"
						sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
						lg-width="100%"
						lg-text-align="center"
						lg-padding="8px 0px 8px 0px"
						transition="opacity 0.2s ease-in-out 0s"
						hover-opacity="0.6"
					>
						Что будет, когда срок действия демо-тарифа закончится?
					</Override>
					<Text margin="0px 0px 0px 0px" font="--base">
						При первичном создании мы предоставляем 15 дней пробного периода для сайта и веб-бота, на основе этих дней, вы можете полноценно оценить функционал бота. 
После завершения пробного периода функционал бота будет отключен до оплаты тарифа "
						<Strong
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Магазин
						</Strong>
						" или выше.
					</Text>
				</Components.QuarklycommunityKitCollapse>
				<Components.QuarklycommunityKitCollapse
					width="100%"
					padding="0px 0px 8px 0px"
					border-width="0px"
					border-style="none"
					lg-width="100%"
					lg-text-align="center"
					sm-margin="0px 0px 6px 0px"
					sm-text-align="center"
				>
					<Override
						slot="Button"
						font="--headline2"
						background="none"
						color="--dark"
						padding="8px 24px 8px 0px"
						sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
						lg-padding="8px 0px 8px 0px"
						transition="opacity 0.2s ease-in-out 0s"
						hover-opacity="0.6"
					>
						Можно ли оплатить тариф по договору?
					</Override>
					<Text margin="0px 0px 0px 0px" font="--base">
						Если вы представляете юридическое лицо и хотите с помощью безналичного перевода оплатить какую-либо конкретную услугу или пополнить лицевой счет сайта, то вы можете выставить счет в панели управления:{" "}
						<Link
							href="https://www.ucoz.ru/help/pro/kak-oplatit-i-ubrat-reklamu#cashless_payment"
							text-decoration-line="initial"
							color="--primary"
							target="_blank"
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							инструкция
							<br />
							<br />
						</Link>
						Помимо этого оплатить тариф вы можете при помощи: Любой банковской карты, ЮMoney, PayPal, SMS, WebMoney.
					</Text>
				</Components.QuarklycommunityKitCollapse>
				<Components.QuarklycommunityKitCollapse
					width="100%"
					padding="0px 0px 8px 0px"
					border-width="0px"
					border-style="none"
					sm-margin="0px 0px 6px 0px"
					sm-text-align="center"
				>
					<Override
						slot="Button"
						font="--headline2"
						background="none"
						color="--dark"
						padding="8px 24px 8px 0px"
						sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
						sm-width="100%"
						lg-width="100%"
						lg-text-align="center"
						lg-padding="8px 0px 8px 0px"
						transition="opacity 0.2s ease-in-out 0s"
						hover-opacity="0.6"
					>
						Как сделать категории в боте?
					</Override>
					<Text margin="0px 0px 0px 0px" font="--base">
						Чтобы создать, изменить или удалить категорию, в панели управления выберите раздел “Интернет-магазин” и перейдите в “Управление категориями”:{" "}
						<Link
							href="https://www.ucoz.ru/help/online-shop/panel-upravleniya-kategoriyami"
							color="--primary"
							text-decoration-line="initial"
							target="_blank"
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							инструкция
						</Link>
					</Text>
				</Components.QuarklycommunityKitCollapse>
				<Components.QuarklycommunityKitCollapse
					width="100%"
					padding="0px 0px 8px 0px"
					border-width="0px"
					border-style="none"
					sm-margin="0px 0px 6px 0px"
					sm-text-align="center"
				>
					<Override
						slot="Button"
						font="--headline2"
						background="none"
						color="--dark"
						padding="8px 24px 8px 0px"
						sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
						lg-width="100%"
						lg-text-align="center"
						lg-padding="8px 0px 8px 0px"
						transition="opacity 0.2s ease-in-out 0s"
						hover-opacity="0.6"
					>
						Можно ли чтобы веб-бота сделали за меня?
					</Override>
					<Text margin="0px 0px 0px 0px" font="--base">
						Да, вы можете заказать разработку в  нашей официальной веб-студии DIvly:{" "}
						<Link
							href="https://bot.divly.pro/"
							target="_blank"
							color="--primary"
							text-decoration-line="initial"
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							https://bot.divly.pro/
						</Link>
					</Text>
				</Components.QuarklycommunityKitCollapse>
				<Components.QuarklycommunityKitCollapse
					width="100%"
					padding="0px 0px 8px 0px"
					border-width="0px"
					border-style="none"
					sm-margin="0px 0px 6px 0px"
					sm-text-align="center"
				>
					<Override
						slot="Button"
						font="--headline2"
						background="none"
						color="--dark"
						padding="8px 24px 8px 0px"
						sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
						lg-width="100%"
						lg-text-align="center"
						lg-padding="8px 0px 8px 0px"
						transition="opacity 0.2s ease-in-out 0s"
						hover-opacity="0.6"
					>
						Куда обращаться, когда возникают вопросы?
					</Override>
					<Text margin="0px 0px 0px 0px" font="--base">
						Все вопросы вы можете задавать внутри нашего чата в МАХ:{" "}
						<Link
							href="https://max.ru/join/nj0GAynGnsPFmszMTqU8ygM8RbCKAGdOJAQfMqBWjTc"
							color="--primary"
							text-decoration-line="initial"
							hover-text-decoration-line="underline"
							target="_blank"
						>
							Перейти
						</Link>
					</Text>
				</Components.QuarklycommunityKitCollapse>
			</Box>
		</Section>
		<Structure
			id="webbot"
			padding="80px 0px 80px 0px"
			cells-number-total="10"
			quarkly-title="Content"
			nout-padding="60px 0px 60px 0px"
			position="relative"
			sm-padding="30px 0px 60px 0px"
			background="--primary"
			display="none"
		>
			<Override
				slot="Content"
				grid-template-columns="repeat(3, 1fr)"
				grid-gap="24px"
				nout-grid-template-columns="1fr"
				sm-overflow-x="hidden"
				sm-overflow-y="hidden"
				md-grid-template-columns="1fr 1fr"
				sm-grid-template-columns="1fr"
			>
				<Override slot="Cell 0th" sm-grid-column="auto / auto" />
				<Override slot="Cell 0" grid-column="1 /span 3" nout-grid-column="auto / auto" md-grid-column="1 / span 2" />
				<Override slot="cell-0">
					<Text
						margin="0px 0px 10px 0px"
						color="--white"
						font="--headline1"
						lg-font="normal 800 32px/1.4 &quot;Montserrat&quot;, sans-serif"
						md-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif"
						sm-text-align="center"
						md-text-align="center"
					>
						Полезные статьи
					</Text>
				</Override>
				<Override slot="cell-1">
					<Box
						background="--white"
						border-radius="32px"
						padding="0px 0px 0px 0px"
						overflow-x="hidden"
						overflow-y="hidden"
						display="flex"
						flex-direction="column"
						justify-content="space-between"
						min-height="540px"
						transition="--transformOut"
						hover-transform="translateY(-5px)"
					>
						<Box min-width="100px" min-height="100px">
							<Image
								src="https://images.unsplash.com/photo-1636743094110-5e153f93ad7e?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=500"
								display="block"
								width="100%"
								max-height="223px"
								margin="0px 0px 14px 0px"
								object-fit="cover"
								srcSet="https://images.unsplash.com/photo-1636743094110-5e153f93ad7e?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=500 500w,https://images.unsplash.com/photo-1636743094110-5e153f93ad7e?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=800 800w,https://images.unsplash.com/photo-1636743094110-5e153f93ad7e?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080 1080w,https://images.unsplash.com/photo-1636743094110-5e153f93ad7e?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1600 1600w,https://images.unsplash.com/photo-1636743094110-5e153f93ad7e?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=2000 2000w,https://images.unsplash.com/photo-1636743094110-5e153f93ad7e?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=2600 2600w,https://images.unsplash.com/photo-1636743094110-5e153f93ad7e?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=3200 3200w"
								sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
							/>
							<Box>
								<Text
									color="--dark"
									font="--headline2"
									margin="0px 20px 16px 20px"
									md-text-align="center"
									as="h3"
								>
									Продвижение интернет-магазина
								</Text>
								<Text color="--dark" font="--base" margin="0px 20px 40px 20px" md-text-align="center">
									Статья о том как правильно и какими способами продвигать магазин в формате Телеграм-бота
								</Text>
							</Box>
						</Box>
						<Link
							href="/prodvizhenie-internet-magazina-v-telegram/"
							color="--white"
							padding="18px 16px 18px 16px"
							text-align="center"
							background="--dark"
							text-decoration-line="initial"
							font="normal 600 16px/1.5 --fontFamily-googleMontserrat"
							transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
							hover-color="--primary"
							hover-background="--white"
							target="_blank"
						>
							Читать далее
						</Link>
					</Box>
				</Override>
				<Override slot="cell-2">
					<Box
						min-height="540px"
						background="--white"
						border-radius="32px"
						padding="0px 0px 0px 0px"
						overflow-x="hidden"
						overflow-y="hidden"
						display="flex"
						flex-direction="column"
						justify-content="space-between"
						transition="--transformOut"
						hover-transform="translateY(-5px)"
					>
						<Box min-width="100px" min-height="100px">
							<Image
								src="https://images.unsplash.com/photo-1521931961826-fe48677230a5?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=500"
								display="block"
								width="100%"
								max-height="223px"
								margin="0px 0px 14px 0px"
								object-fit="cover"
								srcSet="https://images.unsplash.com/photo-1521931961826-fe48677230a5?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=500 500w,https://images.unsplash.com/photo-1521931961826-fe48677230a5?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=800 800w,https://images.unsplash.com/photo-1521931961826-fe48677230a5?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080 1080w,https://images.unsplash.com/photo-1521931961826-fe48677230a5?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1600 1600w,https://images.unsplash.com/photo-1521931961826-fe48677230a5?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=2000 2000w,https://images.unsplash.com/photo-1521931961826-fe48677230a5?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=2600 2600w,https://images.unsplash.com/photo-1521931961826-fe48677230a5?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=3200 3200w"
								sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
							/>
							<Box>
								<Text
									color="--dark"
									font="--headline2"
									margin="0px 20px 16px 20px"
									md-text-align="center"
									as="h3"
								>
									Нужен ли магазин в Телеграм?
								</Text>
								<Text color="--dark" font="--base" margin="0px 20px 40px 20px" md-text-align="center">
									Давайте разберемся, а стоит ли создавать магазин в Телеграм и заниматься его продвижением
								</Text>
							</Box>
						</Box>
						<Link
							href="/dlya-chego-sozdat-magazin-v-telegram/"
							color="--white"
							text-align="center"
							padding="18px 16px 18px 16px"
							text-decoration-line="initial"
							background="--dark"
							font="normal 600 16px/1.5 --fontFamily-googleMontserrat"
							transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
							hover-color="--primary"
							hover-background="--white"
							target="_blank"
						>
							Читать далее
						</Link>
					</Box>
				</Override>
				<Override slot="cell-3">
					<Box
						min-height="540px"
						background="--white"
						border-radius="32px"
						padding="0px 0px 0px 0px"
						overflow-x="hidden"
						overflow-y="hidden"
						display="flex"
						flex-direction="column"
						justify-content="space-between"
						transition="--transformOut"
						hover-transform="translateY(-5px)"
					>
						<Box min-width="100px" min-height="100px">
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/kanaltg.jpg?v=2023-01-18T22:40:45.741Z"
								display="block"
								width="100%"
								max-height="223px"
								margin="0px 0px 14px 0px"
								object-fit="cover"
								srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kanaltg.jpg?v=2023-01-18T22%3A40%3A45.741Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kanaltg.jpg?v=2023-01-18T22%3A40%3A45.741Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kanaltg.jpg?v=2023-01-18T22%3A40%3A45.741Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kanaltg.jpg?v=2023-01-18T22%3A40%3A45.741Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kanaltg.jpg?v=2023-01-18T22%3A40%3A45.741Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kanaltg.jpg?v=2023-01-18T22%3A40%3A45.741Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kanaltg.jpg?v=2023-01-18T22%3A40%3A45.741Z&quality=85&w=3200 3200w"
								sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
							/>
							<Box>
								<Text
									color="--dark"
									font="--headline2"
									margin="0px 20px 16px 20px"
									md-text-align="center"
									as="h3"
								>
									Интеграция Телеграм канала и чата с ботом
								</Text>
								<Text color="--dark" font="--base" margin="0px 20px 40px 20px" md-text-align="center">
									Инструкции по размещению товара в каналах, личных чатах и группах.{" "}
								</Text>
							</Box>
						</Box>
						<Link
							href="/onlayn-prodazha-tovarov-na-kanalakh-i-gruppakh/"
							color="--white"
							padding="18px 16px 18px 16px"
							text-align="center"
							background="--dark"
							text-decoration-line="initial"
							font="normal 600 16px/1.5 --fontFamily-googleMontserrat"
							transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
							hover-color="--primary"
							hover-background="--white"
							target="_blank"
						>
							Читать далее
						</Link>
					</Box>
				</Override>
				<Override slot="Cell 3" sm-display="flex" sm-align-items="center" sm-justify-content="center" />
				<Override slot="cell-4">
					<Box
						min-height="540px"
						background="--white"
						border-radius="32px"
						padding="0px 0px 0px 0px"
						overflow-x="hidden"
						overflow-y="hidden"
						display="flex"
						flex-direction="column"
						justify-content="space-between"
						transition="--transformOut"
						hover-transform="translateY(-5px)"
					>
						<Box min-width="100px" min-height="100px">
							<Image
								src="https://images.unsplash.com/photo-1649424221028-8e7d31f2e3c9?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=700"
								display="block"
								width="100%"
								max-height="223px"
								margin="0px 0px 14px 0px"
								object-fit="cover"
								srcSet="https://images.unsplash.com/photo-1649424221028-8e7d31f2e3c9?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=500 500w,https://images.unsplash.com/photo-1649424221028-8e7d31f2e3c9?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=800 800w,https://images.unsplash.com/photo-1649424221028-8e7d31f2e3c9?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080 1080w,https://images.unsplash.com/photo-1649424221028-8e7d31f2e3c9?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1600 1600w,https://images.unsplash.com/photo-1649424221028-8e7d31f2e3c9?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=2000 2000w,https://images.unsplash.com/photo-1649424221028-8e7d31f2e3c9?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=2600 2600w,https://images.unsplash.com/photo-1649424221028-8e7d31f2e3c9?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=3200 3200w"
								sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
							/>
							<Box>
								<Text
									color="--dark"
									font="--headline2"
									margin="0px 20px 16px 20px"
									md-text-align="center"
									as="h3"
								>
									Продажа электронных товаров в боте
								</Text>
								<Text color="--dark" font="--base" margin="0px 20px 40px 20px" md-text-align="center">
									В Телеграм боте в который вы создадите возможно продавать не только физические товары, но и цифровые (файлы, коды, курсы и пр.)
								</Text>
							</Box>
						</Box>
						<Link
							href="/prodazha-elektronnykh-tovarov-v-telegram/"
							color="--white"
							padding="18px 16px 18px 16px"
							text-align="center"
							background="--dark"
							text-decoration-line="initial"
							font="normal 600 16px/1.5 --fontFamily-googleMontserrat"
							transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
							hover-color="--primary"
							hover-background="--white"
							target="_blank"
						>
							Читать далее
						</Link>
					</Box>
				</Override>
				<Override slot="cell-5">
					<Box
						min-height="540px"
						background="--white"
						border-radius="32px"
						padding="0px 0px 0px 0px"
						overflow-x="hidden"
						overflow-y="hidden"
						display="flex"
						flex-direction="column"
						justify-content="space-between"
						transition="--transformOut"
						hover-transform="translateY(-5px)"
					>
						<Box min-width="100px" min-height="100px">
							<Image
								src="https://images.unsplash.com/photo-1522096823084-2d1aa8411c13?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=700"
								display="block"
								width="100%"
								max-height="223px"
								margin="0px 0px 14px 0px"
								object-fit="cover"
								srcSet="https://images.unsplash.com/photo-1522096823084-2d1aa8411c13?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=500 500w,https://images.unsplash.com/photo-1522096823084-2d1aa8411c13?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=800 800w,https://images.unsplash.com/photo-1522096823084-2d1aa8411c13?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080 1080w,https://images.unsplash.com/photo-1522096823084-2d1aa8411c13?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1600 1600w,https://images.unsplash.com/photo-1522096823084-2d1aa8411c13?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=2000 2000w,https://images.unsplash.com/photo-1522096823084-2d1aa8411c13?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=2600 2600w,https://images.unsplash.com/photo-1522096823084-2d1aa8411c13?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=3200 3200w"
								sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
							/>
							<Box>
								<Text
									color="--dark"
									font="--headline2"
									margin="0px 20px 16px 20px"
									md-text-align="center"
									as="h3"
								>
									Служба поддержки внутри бот-магазина
								</Text>
								<Text color="--dark" font="--base" margin="0px 20px 40px 20px" md-text-align="center">
									Создаем диалог со своими покупателями внутри вашего каталога с товарами
								</Text>
							</Box>
						</Box>
						<Link
							href="/support-bot-magazin/"
							color="--white"
							padding="18px 16px 18px 16px"
							text-align="center"
							background="--dark"
							text-decoration-line="initial"
							font="normal 600 16px/1.5 --fontFamily-googleMontserrat"
							transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
							hover-color="--primary"
							hover-background="--white"
							target="_blank"
						>
							Читать далее
						</Link>
					</Box>
				</Override>
				<Override slot="cell-6">
					<Box
						min-height="540px"
						background="--white"
						border-radius="32px"
						padding="0px 0px 0px 0px"
						overflow-x="hidden"
						overflow-y="hidden"
						display="flex"
						flex-direction="column"
						justify-content="space-between"
						transition="--transformOut"
						hover-transform="translateY(-5px)"
					>
						<Box min-width="100px" min-height="100px">
							<Image
								src="https://images.unsplash.com/photo-1654764449734-bc2d2a2cece2?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=600"
								display="block"
								width="100%"
								max-height="223px"
								margin="0px 0px 14px 0px"
								object-fit="cover"
								srcSet="https://images.unsplash.com/photo-1654764449734-bc2d2a2cece2?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=500 500w,https://images.unsplash.com/photo-1654764449734-bc2d2a2cece2?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=800 800w,https://images.unsplash.com/photo-1654764449734-bc2d2a2cece2?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080 1080w,https://images.unsplash.com/photo-1654764449734-bc2d2a2cece2?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1600 1600w,https://images.unsplash.com/photo-1654764449734-bc2d2a2cece2?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=2000 2000w,https://images.unsplash.com/photo-1654764449734-bc2d2a2cece2?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=2600 2600w,https://images.unsplash.com/photo-1654764449734-bc2d2a2cece2?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=3200 3200w"
								sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
							/>
							<Box>
								<Text
									color="--dark"
									font="--headline2"
									margin="0px 20px 16px 20px"
									md-text-align="center"
									as="h3"
								>
									Уведомления о новых заказах в Телеграм
								</Text>
								<Text color="--dark" font="--base" margin="0px 20px 40px 20px" md-text-align="center">
									Получаем уведомления в Телеграм о заказах с интернет-магазина{" "}
								</Text>
							</Box>
						</Box>
						<Link
							href="/uvedomleniya-o-zakazakh-v-magazine-v-telegram/"
							color="--white"
							padding="18px 16px 18px 16px"
							text-align="center"
							background="--dark"
							text-decoration-line="initial"
							font="normal 600 16px/1.5 --fontFamily-googleMontserrat"
							transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
							hover-color="--primary"
							hover-background="--white"
							target="_blank"
						>
							Читать далее
						</Link>
					</Box>
				</Override>
				<Override slot="cell-7">
					<Box
						min-height="540px"
						background="--white"
						border-radius="32px"
						padding="0px 0px 0px 0px"
						overflow-x="hidden"
						overflow-y="hidden"
						display="flex"
						flex-direction="column"
						justify-content="space-between"
						transition="--transformOut"
						hover-transform="translateY(-5px)"
					>
						<Box min-width="100px" min-height="100px">
							<Image
								src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=500"
								display="block"
								width="100%"
								max-height="223px"
								margin="0px 0px 14px 0px"
								object-fit="cover"
								srcSet="https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=500 500w,https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=800 800w,https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1080 1080w,https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1600 1600w,https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2000 2000w,https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2600 2600w,https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=3200 3200w"
								sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
							/>
							<Box>
								<Text
									color="--dark"
									font="--headline2"
									margin="0px 20px 16px 20px"
									md-text-align="center"
									as="h3"
								>
									Перенос бота клиенту или передача прав
								</Text>
								<Text color="--dark" font="--base" margin="0px 20px 40px 20px" md-text-align="center">
									Как полностью сменить владельца у бота или сделать частичную передачу прав на управление бота
								</Text>
							</Box>
						</Box>
						<Link
							href="/prava-na-bot-magazin/"
							color="--white"
							padding="18px 16px 18px 16px"
							text-align="center"
							background="--dark"
							text-decoration-line="initial"
							font="normal 600 16px/1.5 --fontFamily-googleMontserrat"
							transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
							hover-color="--primary"
							hover-background="--white"
							target="_blank"
						>
							Читать далее
						</Link>
					</Box>
				</Override>
				<Override slot="cell-8">
					<Box
						min-height="540px"
						background="--white"
						border-radius="32px"
						padding="0px 0px 0px 0px"
						overflow-x="hidden"
						overflow-y="hidden"
						display="flex"
						flex-direction="column"
						justify-content="space-between"
						transition="--transformOut"
						hover-transform="translateY(-5px)"
					>
						<Box min-width="100px" min-height="100px">
							<Image
								src="https://images.unsplash.com/photo-1587654780291-39c9404d746b?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=500"
								display="block"
								width="100%"
								max-height="223px"
								margin="0px 0px 14px 0px"
								object-fit="cover"
								srcSet="https://images.unsplash.com/photo-1587654780291-39c9404d746b?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=500 500w,https://images.unsplash.com/photo-1587654780291-39c9404d746b?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=800 800w,https://images.unsplash.com/photo-1587654780291-39c9404d746b?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1080 1080w,https://images.unsplash.com/photo-1587654780291-39c9404d746b?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1600 1600w,https://images.unsplash.com/photo-1587654780291-39c9404d746b?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2000 2000w,https://images.unsplash.com/photo-1587654780291-39c9404d746b?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2600 2600w,https://images.unsplash.com/photo-1587654780291-39c9404d746b?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=3200 3200w"
								sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
							/>
							<Box>
								<Text
									color="--dark"
									font="--headline2"
									margin="0px 20px 16px 20px"
									md-text-align="center"
									as="h3"
								>
									Конструктор верхней части бота
								</Text>
								<Text color="--dark" font="--base" margin="0px 20px 40px 20px" md-text-align="center">
									Генератор HTML-кода для облегченного управление верхней частью сайта
									<br />
								</Text>
							</Box>
						</Box>
						<Link
							href="/create-logo/"
							color="--white"
							padding="18px 16px 18px 16px"
							text-align="center"
							background="--dark"
							text-decoration-line="initial"
							font="normal 600 16px/1.5 --fontFamily-googleMontserrat"
							transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
							hover-color="--primary"
							hover-background="--white"
							target="_blank"
						>
							Читать далее
						</Link>
					</Box>
				</Override>
				<Override slot="cell-9">
					<Box
						min-height="540px"
						background="--white"
						border-radius="32px"
						padding="0px 0px 0px 0px"
						overflow-x="hidden"
						overflow-y="hidden"
						display="flex"
						flex-direction="column"
						justify-content="space-between"
						transition="--transformOut"
						hover-transform="translateY(-5px)"
					>
						<Box min-width="100px" min-height="100px">
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/desingcode.png?v=2024-04-05T12:33:16.321Z"
								display="block"
								width="100%"
								max-height="223px"
								margin="0px 0px 14px 0px"
								object-fit="cover"
								srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/desingcode.png?v=2024-04-05T12%3A33%3A16.321Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/desingcode.png?v=2024-04-05T12%3A33%3A16.321Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/desingcode.png?v=2024-04-05T12%3A33%3A16.321Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/desingcode.png?v=2024-04-05T12%3A33%3A16.321Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/desingcode.png?v=2024-04-05T12%3A33%3A16.321Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/desingcode.png?v=2024-04-05T12%3A33%3A16.321Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/desingcode.png?v=2024-04-05T12%3A33%3A16.321Z&quality=85&w=3200 3200w"
								sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
							/>
							<Box>
								<Text
									color="--dark"
									font="--headline2"
									margin="0px 20px 16px 20px"
									md-text-align="center"
									as="h3"
								>
									Дизайн вашего каталога в Телеграм
								</Text>
								<Text color="--dark" font="--base" margin="0px 20px 40px 20px" md-text-align="center">
									Как правильно редактировать и красиво оформить каталог вашего бота. Правильная работа с кодом (CSS, JS, HTML)
								</Text>
							</Box>
						</Box>
						<Link
							href="/oformlenie-magazina-v-telegram/"
							color="--white"
							padding="18px 16px 18px 16px"
							text-align="center"
							background="--dark"
							text-decoration-line="initial"
							font="normal 600 16px/1.5 --fontFamily-googleMontserrat"
							transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
							hover-color="--primary"
							hover-background="--white"
							target="_blank"
						>
							Читать далее
						</Link>
					</Box>
				</Override>
			</Override>
		</Structure>
		<Section background="--dark" padding="125px 0 125px 0" nout-padding="60px 0 60px 0" position="relative">
			<Override
				slot="SectionContent"
				display="flex"
				align-items="flex-start"
				md-align-items="center"
				md-justify-content="center"
				md-text-align="center"
			/>
			<Text
				margin="0px 0px 24px 0px"
				color="--white"
				font="--headline1"
				nout-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif"
				lg-font="normal 800 26px/1.4 &quot;Montserrat&quot;, sans-serif"
				md-font="normal 800 22px/1.4 &quot;Montserrat&quot;, sans-serif"
				md-text-align="center"
				sm-font="normal 800 20px/1.4 &quot;Montserrat&quot;, sans-serif"
				as="h2"
			>
				Заказать бота интернет-магазин в Максе за 9800 руб.
			</Text>
			<Text
				margin="0px 0px 48px 0px"
				color="--white"
				font="--decsr"
				md-font="normal 500 16px/180% &quot;Montserrat&quot;, sans-serif"
				md-text-align="center"
				sm-font="normal 500 14px/180% &quot;Montserrat&quot;, sans-serif"
			>
				Создание сайтов, магазинов, порталов и лендингов под ключ. Помощь по сайтам,
				<br />
				SEO-продвижение и консультации с вебмастерами.
			</Text>
			<Link
				href="https://bot.divly.pro/?utm_source=ucozbotmain&utm_medium=banner&utm_content=footer-"
				color="--white"
				font="--button"
				text-decoration-line="initial"
				padding="16px 28px 16px 28px"
				background="--primary"
				border-radius="50px"
				transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
				hover-color="--dark"
				hover-background="--white"
				target="_blank"
			>
				Заказать веб-бот под ключ
			</Link>
		</Section>
		<Section
			background="--dark"
			padding="15px 0 15px 0"
			border-style="solid"
			border-color="--color-white"
			border-width="1px 0px 0px 0px"
			position="relative"
		>
			<Override
				slot="SectionContent"
				display="flex"
				align-items="center"
				flex-direction="row"
				grid-gap="16px"
				justify-content="space-between"
				md-flex-direction="column"
				md-align-items="center"
			/>
			<Box>
				<Text margin="0px 0px 0px 0px" color="--white" font="--base">
					<Link
						href="https://ukit.group/"
						color="--white"
						text-decoration-line="initial"
						target="_blank"
						hover-text-decoration-line="underline"
						padding="5px 5px 5px 5px"
					>
						© uKit Group
					</Link>
				</Text>
			</Box>
			<Box
				display="flex"
				grid-gap="32px"
				sm-flex-direction="column"
				sm-display="flex"
				sm-grid-gap="8px"
			>
				<Link
					href="https://www.ucoz.ru/details/"
					color="--white"
					font="--base"
					target="_blank"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					sm-text-align="center"
					padding="5px 5px 5px 5px"
				>
					Юридическая информация
					<Link href="https://www.ucoz.ru/details/" />
				</Link>
				<Link
					href="https://www.ucoz.ru/terms/"
					color="--white"
					font="--base"
					target="_blank"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					sm-text-align="center"
					padding="5px 5px 5px 5px"
				>
					Условия использования
				</Link>
			</Box>
			<LinkBox
				href="https://max.ru/id7710628378_biz"
				target="_blank"
				transition="--opacityOut"
				hover-opacity="0.7"
				color="--primary"
				background="--background"
				border-radius="50%"
			>
				<Icon
					category="fa"
					icon={FaMaxcdn}
					size="30px"
					padding="1px 1px 1px 1px"
					box-shadow="--xl"
				/>
			</LinkBox>
		</Section>
		<Components.ChatMax />
		<Components.EmbedHTML />
		<RawHtml>
			<style place={"endOfHead"} rawKey={"62ab65c921e43d0020961284"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n    scroll-behavior: smooth;\n}\nbody {\n    position: relative !important;\n}"}
			</style>
			<script place={"endOfBody"} rawKey={"639c57f598af799c2def4641"}>
				{"   (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};\n   m[i].l=1*new Date();\n   for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}\n   k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})\n   (window, document, \"script\", \"https://mc.yandex.ru/metrika/tag.js\", \"ym\");\n\n   ym(91719479, \"init\", {\n        clickmap:true,\n        trackLinks:true,\n        accurateTrackBounce:true,\n        webvisor:true\n   });"}
			</script>
			<script place={"endOfHead"} rawKey={"65b906fcebf1ff7fe82ff95a"}>
				{"(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\nnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n})(window,document,'script','dataLayer','GTM-59QRNH');"}
			</script>
			<script async={true} src={"//code.jivo.ru/widget/EsmX5tZp4R"} place={"endOfHead"} rawKey={"69b7f73f921c1a779c7c2cc6"} />
		</RawHtml>
	</Theme>;
});